export const translateToCampaignCode = (programCode) => {
  switch (programCode?.toUpperCase()) {
    case 'YOU':
      return '0044916';
    default:
      return '';
  }
};
